import numeral from "numeral";
import PencilIcon from "../../../components/icon/pencilIcon";
import { cn } from "../../../utils/useFunctions";
import { PdfCard, PdfCardWhite } from "../component/pdf.c.card";
import PdfFooter from "../component/pdf.c.footer";
import PdfHeader from "../component/pdf.c.header";
import { PdfHeaderText } from "../component/pdf.c.headerText";
import PdfLine from "../component/pdf.c.line";
import {
  STYLE_PAGE,
  STYLE_PDF_TEXT_MEDIUM_11,
  STYLE_PDF_TEXT_MEDIUM_13,
  STYLE_PDF_TEXT_SEMIBOLD_BLUE_14,
} from "../styles/pdf.style";

function ExpenseInsuranceDetailTwoPDF({ page, data }) {
  return (
    <div className={cn(STYLE_PAGE)}>
      <PdfHeader />
      <PdfLine />
      <PdfHeaderText
        title="ประกันของคุณ"
        icon="/images/insuranceClibboard.png"
        classNameIcon="w-[35px] h-[24px]"
        classNameTitle="text-[20px] font-bold"
      />

      <PdfCard
        className={"flex flex-col space-y-3"}
        title={"ประกันชีวิต"}
        classNameTitle={"text-[12px] font-[500]"}
      >
        <PdfCardWhite className={cn("px-3")}>
          <div className="flex flex-row w-full ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">
                  สัญญาเพิ่มเติม เอไอเอ มัลติเพย์ ซีไอ *{" "}
                </div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center text-nowrap": true,
              })}
            >
              {`${
                data?.more_details?.aia_mutiplay_ci_more
                  ? numeral(data?.more_details?.aia_mutiplay_ci_more).format(
                      "0,0"
                    )
                  : "-"
              }`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">
                  สัญญาเพิ่มเติม เอไอเอ โทเทิล แคร์ *
                </div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center text-nowrap": true,
              })}
            >
              {`${
                data?.more_details?.aia_total_care_more
                  ? numeral(data?.more_details?.aia_total_care_more).format(
                      "0,0"
                    )
                  : "-"
              }`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">คุ้มครองชีวิตแบบมีระยะเวลา (LT)</div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center text-nowrap": true,
              })}
            >
              {`${
                data?.more_details?.protection_life_lt
                  ? numeral(data?.more_details?.protection_life_lt).format(
                      "0,0"
                    )
                  : "-"
              } ปี`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">ยกเว้นเบี้ยหลัก(LT) กรณีทุพพลภาพ</div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center": true,
              })}
            >
              {`${
                data?.more_details?.except_allowance_lt
                  ? numeral(data?.more_details?.except_allowance_lt).format(
                      "0,0"
                    )
                  : "-"
              }`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <PencilIcon />
                <div className="ml-[5px]">กรอกรายละเอียดเพิ่มเติม</div>
              </div>
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_13, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">รายการ</div>
              </div>
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_13, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">บาท</div>
              </div>
            </div>
          </div>

          <div className="py-[10px]">
            <PdfLine className={"mt-0 mb-0"} />
          </div>

          <div className="flex flex-row w-full ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">
                  อุบัติเหตุ (เอ.ไอ)พร้อมด้วยบันทึกเพิ่มเติม
                </div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center": true,
              })}
            >
              {`${
                data?.more_details?.accident_ai
                  ? numeral(data?.more_details?.accident_ai).format("0,0")
                  : "-"
              }`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">
                  อุบัติเหตุ (เอ.ดี.บี) พร้อมด้วยบันทึกเพิ่มเติม
                </div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center": true,
              })}
            >
              {`${
                data?.more_details?.accident_adb
                  ? numeral(data?.more_details?.accident_adb).format("0,0")
                  : "-"
              }`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">
                  อุบัติเหตุ (เอ.ดี.ดี) พร้อมด้วยบันทึกเพิ่มเติม
                </div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center": true,
              })}
            >
              {`${
                data?.more_details?.accident_add
                  ? numeral(data?.more_details?.accident_add).format("0,0")
                  : "-"
              }`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">การรักษาในโรงพยาบาลและศัลยกรรม</div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center": true,
              })}
            >
              {`${
                data?.more_details?.hospital_treatment_surgery
                  ? numeral(
                      data?.more_details?.hospital_treatment_surgery
                    ).format("0,0")
                  : "-"
              }`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">
                  การรักษาในโรงพยาบาลและศัลยกรรมแบบเหมาจ่าย
                </div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center": true,
              })}
            >
              {`${
                data?.more_details?.hospital_treatment_surgery_lump_sum_payment
                  ? numeral(
                      data?.more_details
                        ?.hospital_treatment_surgery_lump_sum_payment
                    ).format("0,0")
                  : "-"
              }`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">
                  ค่าชดเชยรายวันในการเข้ารักษาตัวในโรงพยาบาล
                </div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center": true,
              })}
            >
              {`${
                data?.more_details?.daily_compensation_for_treatment
                  ? numeral(
                      data?.more_details?.daily_compensation_for_treatment
                    ).format("0,0")
                  : "-"
              }`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">
                  ค่าชดเชยรายวันในการเข้ารักษาตัวในโรงพยาบาล แบบพิเศษ
                </div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center": true,
              })}
            >
              {`${
                data?.more_details?.daily_compensation_for_treatment_special
                  ? numeral(
                      data?.more_details
                        ?.daily_compensation_for_treatment_special
                    ).format("0,0")
                  : "-"
              }`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">
                  ค่าชดเชยการรักษาโรคมะเร็งในโรงพยาบาล (CR)
                </div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center": true,
              })}
            >
              {`${
                data?.more_details?.compensation_for_cancer_treatment_cr
                  ? numeral(
                      data?.more_details?.compensation_for_cancer_treatment_cr
                    ).format("0,0")
                  : "-"
              }`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">
                  ค่าชดเชยโรคร้ายแรงต่อเนื่อง (ECIR) ไม่มีเงินคืน *
                </div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center": true,
              })}
            >
              {`${data?.more_details?.compensation_ecir?numeral(data?.more_details?.compensation_ecir).format(
                "0,0"
              ):'-'}`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">
                ค่าชดเชยโรคร้ายแรง (AIA Supercare) มีเงินคืน *
                </div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center": true,
              })}
            >
              {`${data?.more_details?.compensation_aia_supercare?numeral(
                data?.more_details?.compensation_aia_supercare
              ).format("0,0"):'-'}`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">
                ค่าชดเชยโรคร้ายแรง (AIA ProCare) มีเงินคืน *
                </div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center": true,
              })}
            >
              {`${data?.more_details?.compensation_aia_procare?numeral(data?.more_details?.compensation_aia_procare).format(
                "0,0"
              ):'-'}`}
            </div>
          </div>
        </PdfCardWhite>
      </PdfCard>
      <PdfFooter page={page} />
    </div>
  );
}

export default ExpenseInsuranceDetailTwoPDF;
